import { useWaitForTransactionEvm } from '@src/hooks/evm/useWaitForTransaction'
import { useWaitForTransactionSolana } from '@src/hooks/solana/useWaitForTransaction'
import { useWaitForTransactionTron } from '@src/hooks/tron/useWaitForTransaction'

export const useWaitForTransaction = () => {
    const evmHandler = useWaitForTransactionEvm()
    const solanaHandler = useWaitForTransactionSolana()
    const tronHandler = useWaitForTransactionTron()

    const waitForTransactionReceipt = async (
        hash: string | `0x${string}`,
        isSolana: boolean = false,
        isTron: boolean = false
    ) => {
        if (isSolana) {
            return solanaHandler.waitForTransactionReceipt(hash)
        }
        if (isTron) {
            return tronHandler.waitForTransactionReceipt(hash)
        }
        return evmHandler.waitForTransactionReceipt(hash as `0x${string}`)
    }

    return { waitForTransactionReceipt }
}
